import { AgmCoreModule } from '@agm/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './features/auth/auth.module';
import { AuthInterceptor } from './features/private/interceptors/auth.interceptor';
import { PublicModule } from './features/public/public.module';
import { HttpMockInterceptor } from './shared/interceptors/http.interceptor';
import { DataService } from './shared/services/data.service';
import { SharedModule } from './shared/shared.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { PullToRefreshComponent } from './pull-to-refresh/pull-to-refresh.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { ar_EG } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import ar from '@angular/common/locales/ar';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzMessageModule } from 'ng-zorro-antd/message';

registerLocaleData(ar);

@NgModule({
  declarations: [AppComponent, PullToRefreshComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    NzMessageModule,
    SharedModule,
    NgxSpinnerModule,
    PublicModule,
    NgImageSliderModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDtrTzC8evG8i7SjFqNMks7p6ALESEwwO8',
      libraries: ['places']
    }),
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
  ],
  providers: [
    Meta,
    DataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpMockInterceptor,
      multi: true
    },
    { provide: NZ_I18N, useValue: ar_EG }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
